import type { IsoDate } from '@/lib/isoDate'

export interface SourceImage {
  readonly file: Blob
  readonly bitmap: ImageBitmap
  readonly previewBitmap: ImageBitmap
  readonly width: number
  readonly height: number
  readonly fileName: string
  readonly mimeType: string
  readonly capturedDate: IsoDate | null
  readonly notice: SourceImageNotice | null
}

export enum SourceImageNotice {
  FirstFrame = 'first-frame',
}

export function disposeSource(source: SourceImage): void {
  source.bitmap.close()
  source.previewBitmap.close()
}
